import { StoreApi, UseBoundStore, useStore } from "zustand";
import { WechatChatStoreType, wechatChatStore } from "./wechat-chat-store";
import {
  wechatChatPersistentStore,
  WechatChatPersistentStoreType,
} from "./wechat-chat-persistent-store";

export const useWechatChatStore = useStore.bind(
  null,
  wechatChatStore.getStore()
) as UseBoundStore<StoreApi<WechatChatStoreType>>;

export const useWechatChatPersistentStore = useStore.bind(
  null,
  wechatChatPersistentStore.getStore()
) as UseBoundStore<StoreApi<WechatChatPersistentStoreType>>;
